import React, { useRef, useEffect, useState, JSX } from 'react';
import LineCheckInput from './LineCheckInput';
import Success from './Success';
import { Spinner } from 'react-bootstrap';
import { viewport } from '../../utils/utils';
import Styles from './LineCheckOverlay.module.scss';
import FalconMessage from '../FalconMessage/FalconMessage';
export interface LineCheckOverlaySchema {
  props: any;
  productName: string;
  handleModalClick: any;
  onSuccess: any;
  setAddressNotFilled:any;
  setIndivialOpen:any;
  indivialOpen:any;
  isAvailable:boolean;
}
const LineCheckOverlay = ({
  props,
  productName,
  handleModalClick,
  onSuccess,
  setAddressNotFilled,
  setIndivialOpen,
  indivialOpen,
  isAvailable
}: LineCheckOverlaySchema): JSX.Element => {
  const addressRef = useRef<HTMLInputElement>(null);
  const viewPort = viewport();
  const [advSearch, setAdvSearch] = useState<boolean>(false);
  const successRef = useRef<HTMLInputElement>(null);
  const executeScroll = () => {
    setTimeout(() => {
      successRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
      addressRef.current?.focus();
    }, 1000);
  };
  const handleData = (data: any) => {
    setAdvSearch(true);
  };
  const onHandleClick = () => {
    addressRef?.current?.focus();
  };
  useEffect(() => {
    if (props?.selectedAddress?.concatedAddress) {
      addressRef?.current?.blur();
    }
  }, [props?.selectedAddress?.concatedAddress]);

  const onInputChange = (e: any) => {
    props.onChange(e);
  };
  const btn = (
    <div>
      <span className='mobileTable'>
        <span
          className='changeBtn'
          onClick={props?.EditButtonClick}
          hidden={!props?.linecheckResponse?.eligibleBundle}
        >
          <span className={Styles['changeTxt']}>
            {viewPort === 'mobile'
              ? props?.lineCheckContent?.changeTextMob
              : props?.lineCheckContent?.changeText}
          </span>
        </span>
      </span>
    </div>
  );
  return (
    <>
      <div onClick={onHandleClick} className={Styles['linecheckOverlay']}>
        <div className={props?.linecheckResponse?.eligibleBundle && Styles['maincontainerMob']}>
          {props.lineCheckContent?.popUpTitle && (
            <div className={Styles['headerContainer']} ref={successRef}>
              {advSearch ? props.lineCheckContent?.popUpTitle : ''}
              <img
                  onClick={handleModalClick}
                  className={Styles['closeIcon']}
                  width={13.5}
                  height={13.5}
                  alt='close'
                  src={props?.lineCheckContent?.linecheckIcons?.[0]?.close?.filename}
                />
            </div>
          )}
          <div className={Styles['sub-container']}>
            
            {props?.linecheckResponse?.eligibleBundle &&
              (props?.errorMessage ||
              (!props?.errorMessage && props?.linecheckResponse?.eligibleBundle?.length > 1 && isAvailable) ? (
                <img
                  src={props?.lineCheckContent?.linecheckIcons?.[0]?.tick?.filename}
                  height={'32px'}
                  width={'32px'}
                  alt='linecheckIcons'
                />
              ) : (
                <img
                  src={props?.lineCheckContent?.linecheckIcons?.[0]?.notAvailableIcon?.filename}
                  height={'32px'}
                  width={'32px'}
                  alt='linecheckIcons'
                />
              ))}
            {(props?.lineCheckContent?.linecheckTitle ||
              props?.lineCheckContent?.successLinecheckTitle) && (
              <>
                <h4 className={Styles['linechecktitle']}>
                  {!props?.FetchingLineCheck && props?.linecheckResponse?.eligibleBundle
                    ? !isAvailable
                      ? props?.lineCheckContent?.noConnectionTitle.replace('{0}', productName)
                      : props?.lineCheckContent?.successLinecheckTitle.replace('{0}', productName)
                    : props?.lineCheckContent?.linecheckTitle.replace('{0}', productName)}
                </h4>
              </>
            )}
          </div>
          {/* falcon message for indivial linecheck */}
          {indivialOpen?.indErrorOpen &&
                      props?.lineCheckContent?.errorMessageBlok?.length > 0 && (
                        <div className={Styles['falcon-message']}>
                          <FalconMessage content={props?.lineCheckContent?.errorMessageBlok?.[0]} />
                        </div>
                      )}
          {!props?.linecheckResponse?.eligibleBundle ? (
            <>
              <LineCheckInput
                content={props.lineCheckContent}
                parentCallback={props.handleSelection}
                parentAddress={props.selectedAddress?.concatedAddress}
                ref={addressRef}
                isAddressNotFilled={props.isAddressNotFilled}
                name='lineCheck'
                onChange={onInputChange}
                apiError={props.apiError}
                setApiError={props.setApiError}
                setFetchingLineCheck={props.setFetchingLineCheck}
                onData={handleData}
                FetchingLineCheck={props?.isFetchingLineCheck}
                checkAvailability={props?.checkAvailability}
                setIndivialOpen={setIndivialOpen}
                indivialOpen={indivialOpen}
                setAddressNotFilled={setAddressNotFilled}
              />
              {props?.isFetchingLineCheck &&
              !props?.apiError &&
              addressRef?.current?.value !== '' ? (
                <div className={Styles['containers']}>
                  <div className={`spinner-border ${Styles['spinnerload']}`} role='status'></div>
                  {props?.lineCheckContent?.checkServiceText && (
                    <div className={Styles['checktext']}>
                      {props?.lineCheckContent?.checkServiceText}
                    </div>
                  )}
                </div>
              ) : (
                ""
              )}
            </>
          ) : (
            <>
              <Success
                content={
                  <span data-hj-suppress>
                    {props?.selectedAddress?.concatedAddress}
                    {btn}
                  </span>
                }
                isLoading={props?.isFetchingLineCheck}
                uploadDownload={props?.linecheckResponse?.maxUploadDownloadSpeed}
                textContent={props?.content}
                eligibleBundle={props?.linecheckResponse?.eligibleBundle}
                tooltipcontent={props?.lineCheckContent?.speedTooltip}
                onSuccess={onSuccess}
                isAvailable={isAvailable}
              />
            </>
          )}
          {props?.lineCheckContent?.helpText && !addressRef.current?.value ? (
            <div className={Styles['helpText']}>
              {!props?.isFetchingLineCheck && props?.linecheckResponse?.eligibleBundle
                ? ''
                : props?.lineCheckContent?.helpText}
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </>
  );
};
export default LineCheckOverlay;
